import { render } from "./HistSCV3.vue?vue&type=template&id=1923f134&scoped=true"
import script from "./HistSCV3.vue?vue&type=script&lang=js"
export * from "./HistSCV3.vue?vue&type=script&lang=js"

import "./HistSCV3.vue?vue&type=style&index=0&id=1923f134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1923f134"]])

export default __exports__